import React, { useRef, useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Mensaje, MensajeSiNo } from '../../mensajes';

import { Dimmer } from "../../spinner";

import { validaSoloNumero, formatMoneda, validaMonto, formatoMonto } from '../../../util/varios';
import TablaDeudaComercio from '../actividadEconomica/tablaDeudaComercios';
import TablaPagosComercio from '../actividadEconomica/tablaPagosComercios';
import TablaFacturasContribuyente from '../actividadEconomica/tablaFacturasContribuyentes';
import TablaHistoricoRetenciones from '../actividadEconomica/tablaHistoricoRetenciones'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import TablaDatosApuestas from './tablaDatosApuesta'
import TablaDeudaApuesta from './tablaDeudaApuesta';
import TablaHistoricosApuestas from './tablaHistoricoApuestas';



export const ModalContribuyenteApuesta = (props) => {

    /*  variables de estados */

    let op = require('../../../../src/modulos/datos');

    const btnCancela = useRef();
    const btnAcepta = useRef();
    const [mostrar, setMostrar] = useState(false);
    const [titulo, setTitulo] = useState();
    const [msg, setMsg] = useState();
    const [mostrar1, setMostrar1] = useState(false);
    const [titulo2, setTitulo2] = useState();
    const [msg2, setMsg2] = useState();
    const [contar1, setContar1] = useState(0);
    const [activate, setActivate] = useState(false);
    const txtCodigoCiu = useRef();
    const txtIdactividad = useRef();
    const txtAlicuota = useRef();
    const txtDescripcionActi = useRef();
    const txtAnios = useRef();
    const txtMinimo = useRef();
    const txtActualizada = useRef();
    const txtCodActividad = useRef();
    const [deshabilitado, setDeshabilitado] = useState(false);
    const [operacion, setOperacion] = useState(0);
    const [tabIndex, setTabIndex] = useState(0);
    const [visible, setVisible] = useState(false);
    const [idUsuario, setIdUsuario] = useState();
    const [declaWeb, setDeclaWeb] = useState();
    const txtIdComercio = useRef();
    const txtRitm = useRef();
    const txtNumPatente = useRef();
    const txtDenominacionCome = useRef();
    const txtDireccionContri = useRef();
    const txtEmailContri = useRef();
    const txtCedula = useRef();
    const cmbStatus = useRef();
    const txtObserStatus = useRef();
    const [fechaSistema, setFechaSistema] = useState(localStorage.getItem('fechasistema'));
    const [anio, setAnio] = useState([])


    const handleCloseSi = () => {
        setMostrar1(false);
    };

    const handleCloseNo = () => {
        setMostrar1(false);
    };


    const handleCloseMensa = () => {
        setMostrar(false);
    }


    const handleInputChange = (event) => {
        if (event.which === 13) {
            if (event.target.id === 'inputCodigo') {
                txtCodActividad.current.focus();
            } else if (event.target.id === 'inputCodigoActi') {
                txtCodigoCiu.current.focus();
            } else if (event.target.id === 'inputCodigoCiu') {
                txtAnios.current.focus();
            } else if (event.target.id === 'inputAnio') {
                txtDescripcionActi.current.focus();
            } else if (event.target.id === 'inputDescripcion') {
                txtAlicuota.current.focus();
            } else if (event.target.id === 'inputActualizada') {
                btnAcepta.current.focus();
            }
        } else if (typeof (event.which) === 'undefined') {
            return false;
        } else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false;//alert(e.which);
    };

    const handleInputMontoChange = (event) => {
        //setActiveIndex(1);
        validaMonto(event);
        if (event.which === 13 || typeof (event.which) === 'undefined') {

            if (event.target.value === '' || parseFloat(event.target.value.trim().replace(/\./g, "").replace(",", ".")) === 0.00) {
                event.target.value = '0,00'
            }
            event.target.value = (formatoMonto(event.target.value));
            let char1 = event.target.value.substring(0, 1);
            let char2 = event.target.value.substring(1, 2);
            if (char1 === '0' && char2 !== ',') {
                event.target.value = event.target.value.substring(1, event.target.value.legth);
            }
            if (event.which === 13) {
                if (event.target.id === 'inputAlicuota') {
                    txtMinimo.current.focus();
                } else if (event.target.id === 'inputMinimo') {
                    txtActualizada.current.focus();
                }
            }

        } else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false;//alert(e.which);
    };

    const handleInputNumChange = (event) => {
        //setActiveIndex(1);
        validaSoloNumero(event);
        if (event.which === 13 || typeof (event.which) === 'undefined') {

            if (event.which === 13) {
                if (event.target.id === 'inputAnio') {
                    txtDescripcionActi.current.focus();
                }
            }

        } else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false;//alert(e.which);
    };




    const salir = () => {

        props.onHideCancela();
    }
    const handlerClickTab = (index, lastIndex, event) => {
        //alert("Tab seleccionado: " + index + " .\ Tab anterior seleccionado: " + lastIndex);
        if (operacion === 1 && (index === 2 || index === 3)) {
            setTabIndex(0);
        } else {
            setTabIndex(index);
        }
    }

    useEffect(() => {

        let anioact = JSON.parse(localStorage.getItem('efiscalanio'));
        var nanio = []
        var aini = 1999;
        var afin = parseInt(anioact);

        for (let i = 1; i + aini <= afin; i++) {
            nanio.push({ anio: aini + i });

        }
        setAnio(nanio);
     
    }, []);

    return (
        <Modal
            {...props}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            keyboard={false}
            onShow={() => {
                setDeshabilitado(props.deshabilitado);
                setOperacion(props.operacion);

                setVisible(false);
                setIdUsuario(props.idusuario);
                setDeclaWeb(props.declaweb);
                setTabIndex(0);
                setContar1(0);
            }}

        >
            <Modal.Header className='azulGradiant'>
                <Modal.Title style={{ color: "#fff" }}>{operacion === 1 ? 'Agregar Estado Cuenta.' : operacion === 2 ? 'Editar Estado Cuenta.' : operacion === 3 ? 'Eliminar Estado Cuenta.' : 'Registro Contribuyente de Juegos y Apuestas Licitas.'}</Modal.Title>
                <button ref={btnCancela} className="btn" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={salir}>
                    <i className="far fa-window-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body style={{ color: "rgb(106, 115, 123)" }}>
                <Mensaje titulo={titulo} mensaje={msg}
                    show={mostrar}
                    onHide={handleCloseMensa} />
                <MensajeSiNo titulo={titulo2} mensaje={msg2}
                    show={mostrar1}
                    onHideSi={handleCloseSi} onHideNo={handleCloseNo} />
              <Dimmer active={activate} inverted>
       
      </Dimmer>
                <div style={{ height: "70vh", overflow: "auto" }}>


                    <Tabs
                        //scrollButtons="on"

                        forceRenderTabPanel
                        //defaultIndex={0}
                        selectedIndex={tabIndex}
                        onSelect={handlerClickTab}
                        onDoubleClick={() => {
                            if (operacion === 2) {
                                setVisible(true);
                            }

                        }}
                    >
                        <TabList>
                            <Tab>Datos Generales</Tab>
                            <Tab>Deudas del Contribuyente</Tab>
                            <Tab>Historicos de Pagos</Tab>


                        </TabList>

                        <TabPanel>
                            <div className=" container-fluid row col-md-12 rounded border border-primary" style={{ margin: 0, padding: "10px", height: 'auto', fontFamily: 'Times New Roman, Times, serif' }}>

                                <div className='container-fluid row col-md-12' style={{ margin: 0, padding: '5px' }}>

                                    <div class="container-fluid input-group input-group-sm col-md-3" style={{ padding: 0, height: 27 }}>
                                        <div class="input-group-prepend">
                                            <span class="input-group-text" id="inputGroup-sizing-sm"> Código Contribuyente: </span>
                                        </div>
                                        <input type="text" disabled={true} ref={txtIdComercio} className="form-control form-control-sm" defaultValue={props.comercio ? props.comercio.idcomercio !== null ? props.comercio.idcomercio.trim() : '' : ''} id="inputCodigo" />
                                    </div>

                                    <div class="container-fluid input-group input-group-sm col-md-3" style={{ padding: 0, height: 27 }}>
                                        <div class="input-group-prepend">
                                            <span class="input-group-text" id="inputGroup-sizing-sm">N° RITM: </span>
                                        </div>
                                        <input type="text" ref={txtRitm} className="form-control form-control-sm" defaultValue={props.comercio ? props.comercio.ritm.trim() : ''} id="inputRitm" onKeyUp={handleInputChange} onBlur={handleInputChange} />
                                    </div>

                                    <div class="container-fluid input-group input-group-sm col-md-2" style={{ padding: 0, height: 27 }}>
                                        <div class="input-group-prepend">
                                            <span class="input-group-text" id="inputGroup-sizing-sm">Año: </span>
                                        </div>
                                        <select name="" disabled={deshabilitado} ref={cmbStatus} className=" colform-control text-uppercaseform-control-sm" defaultValue={props.comercio ? props.comercio.status !== null ? props.comercio.status : '' : ''} >
                                            {anio && anio.map(a => (
                                                <option key={a.anio} value={a.anio}>{a.anio}</option>
                                            ))}
                                        </select>
                                    </div>

                                    <div class="input-group input-group-sm col-md-2" style={{ padding: 0, height: 27 }}>
                                        <div class="input-group-prepend">
                                            <span class="input-group-text" id="inputGroup-sizing-sm">Mes:</span>
                                        </div>
                                        <select name="" disabled={deshabilitado} ref={cmbStatus} className=" colform-control text-uppercaseform-control-sm" defaultValue={props.comercio ? props.comercio.status !== null ? props.comercio.status : '' : ''} >
                                            {/* {props.statuscome && props.statuscome.map(sta => (
                                                <option key={sta.idstatus} value={sta.idstatus}>{sta.descripcion.trim()}</option>
                                            ))} */}
                                        </select>
                                    </div>




                                </div>

                                <div className='row col-md-12 justify-content-center rounded border border-primary ' style={{ padding: '10px', margin: 0 }}>


                                    <div className="col-md-3 mx-auto" style={{ margin: 0, padding: 0 }}>
                                        Datos del Contribuyente
                                    </div>
                                    <div className="col-md-9" >

                                    </div>

                                    <div className='row col-md-6 mx-auto'>
                                        <div class="input-group input-group-sm col-md-12" style={{ padding: 0, height: 27 }}>
                                            <div class="input-group-prepend">
                                                <span class="input-group-text" id="inputGroup-sizing-sm"> Denominacion Comercial: </span>
                                            </div>
                                            <input type="text" ref={txtRitm} className="form-control form-control-sm" defaultValue={props.comercio ? props.comercio.nombre !== null ? props.comercio.nombre.trim() : '' : ''} id="inputRitm" onKeyUp={handleInputChange} onBlur={handleInputChange} />
                                        </div>
                                        <div class="input-group input-group-sm col-md-6" style={{ padding: 0, height: 27 }}>
                                            <div class="input-group-prepend">
                                                <span class="input-group-text" id="inputGroup-sizing-sm"> Rif: </span>
                                            </div>
                                            <input type="text" ref={txtRitm} className="form-control form-control-sm" defaultValue={props.comercio ? props.comercio.rif !== null ? props.comercio.rif.trim() : '' : ''} id="inputRitm" onKeyUp={handleInputChange} onBlur={handleInputChange} />
                                        </div>

                                        <div class="input-group input-group-sm col-md-6" style={{ padding: 0, height: 27 }}>
                                            <div class="input-group-prepend">
                                                <span class="input-group-text" id="inputGroup-sizing-sm"> N° Telfono: </span>
                                            </div>
                                            <input type="text" ref={txtRitm} className="form-control form-control-sm" defaultValue={props.comercio ? props.comercio.telefono !== null ? props.comercio.telefono.trim() : '' : ''} id="inputRitm" onKeyUp={handleInputChange} onBlur={handleInputChange} />
                                        </div>


                                    </div>

                                    <div className='row col-md-6 mx-auto'>



                                        <div class="input-group input-group-sm col-md-6" style={{ padding: 0, height: 27 }}>
                                            <div class="input-group-prepend">
                                                <span class="input-group-text" id="inputGroup-sizing-sm">N° Licencia: </span>
                                            </div>
                                            <input type="text" ref={txtRitm} className="form-control form-control-sm" defaultValue={props.comercio ? props.comercio.numerolicencia !== null ? props.comercio.numerolicencia.trim() : '' : ''} id="inputRitm" onKeyUp={handleInputChange} onBlur={handleInputChange} />
                                        </div>

                                        <div class="input-group input-group-sm col-md-6" style={{ padding: 0, height: 27 }}>
                                            <div class="input-group-prepend">
                                                <span class="input-group-text" id="inputGroup-sizing-sm">Sector Catastral: </span>
                                            </div>
                                            <input type="text" ref={txtRitm} className="form-control form-control-sm" defaultValue={props.comercio ? props.comercio.sectorcatastral !== null ? props.comercio.sectorcatastral.trim() : '' : ''} id="inputRitm" onKeyUp={handleInputChange} onBlur={handleInputChange} />
                                        </div>

                                        <div class="input-group input-group-sm col-md-12" style={{ padding: 0, height: 27 }}>
                                            <div class="input-group-prepend">
                                                <span class="input-group-text" id="inputGroup-sizing-sm">Dirección: </span>
                                            </div>
                                            <textarea type="area" disabled={deshabilitado} ref={txtDireccionContri} rows={1} className="form-control form-control-sm" id="inputDireccionContri" defaultValue={props.comercio ? props.comercio.direccion !== null ? props.comercio.direccion.trim() : '' : ''} onKeyUp={handleInputChange} />
                                        </div>
                                    </div>








                                </div>

                                <div className="row col-md-12 mx-auto" style={{ margin: 0, padding: 0, marginTop: '2%' }}>
                                    <div className='col-md-12' style={{ margin: 'auto' }}>
                                        <h4> Datos del Juego o Apuesta Licita</h4>
                                    </div>
                                    <div className='col-md-12'>
                                        <TablaDatosApuestas />
                                    </div>
                                </div>




                            </div>
                        </TabPanel>

                        <TabPanel>
                            <TablaDeudaApuesta tabDeuda={props.deuda} idcomercio={props.comercio && props.comercio.idcomercio}/>
                        </TabPanel>

                        <TabPanel>
                            <TablaHistoricosApuestas />
                        </TabPanel>




                    </Tabs>

                </div>
            </Modal.Body>
            <Modal.Footer >
                {/*  <button className="btn btn-primary col-md-2"><i className="fas"> Aceptar</i></button> */}
                <button ref={btnCancela} onClick={salir} className="btn btn-danger col-md-2"><i className="fas fa-window-close"> Cancelar</i></button>
                <button ref={btnCancela} onClick={salir} className="btn btn-danger col-md-2"><i className="fas fa-window-close"> Salir</i></button>

            </Modal.Footer>
        </Modal>
    );
}